import { Chip, TableCell, TableRow, Typography } from "@mui/material"
import { Dispatch, SetStateAction, useContext } from "react"
import { MainContext } from "../../controllers/main"
import { useCmdPressed } from "../../controllers/cmdPressed"
import NotificationTemplate from "../../models/notificationTemplate"
import { useNavigate } from "react-router-dom"
import TitleTableCell from "../global/titleTableCell"
import TranslationsStack from "../global/translationsStack"
import PrimaryBadge from "../global/primaryBadge"
import {
  calculateTimeElapsed,
  capitalizeFirstCharacter,
} from "../../services/utilities/utility"
import { NotificationTemplateValidationStatus } from "../../services/config/enum"
import { EmailRounded } from "@mui/icons-material"

const TemplatesListRow = ({
  item,
  selectedTemplate,
  setSelectedTemplate,
  forDialog,
}: {
  item: NotificationTemplate
  selectedTemplate?: NotificationTemplate
  setSelectedTemplate?: Dispatch<SetStateAction<NotificationTemplate>>
  forDialog?: boolean
}) => {
  const navigate = useNavigate()
  const { setAnimation } = useContext(MainContext)
  const cmdPressed = useCmdPressed()

  return (
    <TableRow
      hover={
        !forDialog ||
        item.validationStatus === NotificationTemplateValidationStatus.VALID
      }
      style={{
        cursor:
          !forDialog ||
          item.validationStatus === NotificationTemplateValidationStatus.VALID
            ? "pointer"
            : "default",
        backgroundColor:
          selectedTemplate && selectedTemplate.id === item.id
            ? "lightgray"
            : null,
        opacity:
          forDialog &&
          item.validationStatus !== NotificationTemplateValidationStatus.VALID
            ? 0.5
            : 1,
      }}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
      onClick={() => {
        if (!forDialog) {
          if (cmdPressed) {
            window.open(`${window.location.href}/${item.id}`)
          } else {
            setAnimation(false)
            setTimeout(() => {
              navigate(`/templates/${item.id}`)
            }, 250)
          }
        } else if (
          setSelectedTemplate &&
          item.validationStatus === NotificationTemplateValidationStatus.VALID
        ) {
          setSelectedTemplate(item)
        }
      }}
    >
      <TableCell style={{ position: "relative" }}>
        {item.stage === "PUBLISHED" || item.hasSibling ? (
          <Chip
            size="small"
            label="Live"
            color="success"
            style={{ position: "relative", zIndex: 1 }}
          />
        ) : item.stage === "ARCHIVED" ? (
          <Chip
            size="small"
            label="Archived"
            style={{ position: "relative", zIndex: 1 }}
          />
        ) : (
          <Chip
            size="small"
            label="Draft"
            color="warning"
            style={{ position: "relative", zIndex: 1 }}
          />
        )}
        {item.hasSibling ? (
          <Chip
            size="small"
            label="Draft"
            color="warning"
            style={{ position: "absolute", left: 18 }}
          />
        ) : null}
      </TableCell>
      <TitleTableCell title={item.handle} id={item.id} />
      <TableCell>
        <TranslationsStack documentItems={item.document.items} />
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          label={
            item.validationStatus ===
            NotificationTemplateValidationStatus.NOT_CHECKED
              ? "Not checked"
              : capitalizeFirstCharacter(item.validationStatus.toLowerCase())
          }
          color={
            item.validationStatus ===
            NotificationTemplateValidationStatus.NOT_CHECKED
              ? "default"
              : item.validationStatus ===
                NotificationTemplateValidationStatus.VALID
              ? "success"
              : "warning"
          }
        />
      </TableCell>
      <TableCell>
        <PrimaryBadge
          count={capitalizeFirstCharacter(item.type.toLowerCase())}
          icon={<EmailRounded style={{ fontSize: 12 }} />}
        />
        {/* <PrimaryBadge
          count={capitalizeFirstCharacter(item.type.toLowerCase())}
          icon={
            item.type === NotificationTemplateType.EMAIL ? (
              <EmailRounded style={{ fontSize: 12 }} />
            ) : item.type === NotificationTemplateType.PUSH ? (
              <NotificationsActiveRounded style={{ fontSize: 12 }} />
            ) : (
              <SmartphoneRounded style={{ fontSize: 12 }} />
            )
          }
        /> */}
      </TableCell>
      <TableCell>
        <Chip
          label={
            item.format === "MJML"
              ? item.format
              : capitalizeFirstCharacter(item.format.toLowerCase())
          }
          size="small"
        />
      </TableCell>
      <TableCell style={{ minWidth: 120 }}>
        <Typography variant="caption">
          {calculateTimeElapsed(item.updatedAt)}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

export default TemplatesListRow
